import styles from "../../foryou/_components/DesctopComponents/Media.module.scss";
import Heading from "../../../components/shared/Heading";
import React from "react";
import { useTranslation } from "react-i18next";
import AddReview from "../../../components/icons/details/AddReview";
import LikeRevItem from "../../../components/icons/details/LikeRevItem";
import useWindowSize from "../../../hooks/useWindowSize";
import { formatLikeCount, truncateString } from "../../../utils/helpers";
import DotsLoader from "../../../components/icons/DotsLoader";
import LikedRevItem from "../../../components/icons/details/LikedRevItem";
import { setLoginModal } from "../../../store/slices/modals.slice";
import { useDispatch } from "react-redux";

type Review = {
  id: number;
  external_id: string;
  author: string;
  content: string;
  created_at: string;
  updated_at: string;
  url: string;
  language: string;
  liked: boolean;
  replies: any[];
  user: null | User;
  like_count?: number;
};

type User = {
  id: number;
  name: string;
  avatarUrl?: string;
};

interface IProps {
  setOpenModal: any;
  setCurrentReview: any;
  data: Review[];
  loadingState: boolean;
  likeReviewHandler: (id: number, liked: boolean) => void;
}

const Reviews = ({ setOpenModal, setCurrentReview, data, loadingState, likeReviewHandler }: IProps) => {
  const { t, i18n } = useTranslation();
  const { windowSize } = useWindowSize();
  const dispatch = useDispatch();
  const isMobile = windowSize === "mobile";
  const dirData = i18n.language === "ar" ? "rtl" : "ltr";

  return (
    <div className={styles.wrapper}>
      <div className={styles.reviewsHeading}>
        <Heading title={t("reviews")} counter={`${data?.length || 0}`} />
          <div
            onClick={() => {
              setCurrentReview(undefined);
              setOpenModal(true);
            }}
            className={styles.addReviewButton}
          >
            <AddReview />
            <span>{t("revModal1")}</span>
          </div>
      </div>
      {(loadingState || (data && data.length > 0)) && (
        <div id={"reviewsWrapper"} className={styles.cardWrapperRev}>

          {loadingState ? (
            <DotsLoader />
          ) : (
            data?.map((review: Review, index: number) => (
              <div
                key={index}
                className={styles.reviewCard}
                onClick={() => {
                  setCurrentReview(review);
                  setOpenModal(true);
                }}
              >
                <div className={styles.reviewText}>{truncateString(review?.content, isMobile ? 120 : 180)}</div>
                <div className={styles.authorWrapper}>
                  <div className={styles.reviewAuthor}>
                    <div dir={dirData} className={styles.av}>
                      {review?.author[0]}
                    </div>
                    <div className={styles.authorName}>{review?.author}</div>
                  </div>
                  <div
                    onClick={(e) => {
                      e.stopPropagation();
                      const token = localStorage.getItem("accessToken");
                      if (!token) {
                        dispatch(setLoginModal(true));
                        return;
                      }

                      likeReviewHandler(review.id, review.liked);
                    }}
                    className={styles.reviewVotes}
                  >
                    <LikedRevItem extraClass={`${styles.hoveredRev} ${review.liked && styles.likedRev}`} />
                    <LikeRevItem />
                    {(review?.like_count ?? 0) !== 0 && <span>{formatLikeCount(review?.like_count)}</span>}
                  </div>
                </div>
              </div>
            ))
          )}
        </div>
      )}

    </div>
  );
};

export default Reviews;
